<template>
  <div v-if="IsEnableTimeOff" class="col-md-12" style="height: 100%;overflow-x:hidden">
    <div class="row" style="padding-top: 15px;">
      <div
        class="col-md-12"
        style="margin-bottom: 10px;"
      >Please select the date range to apply leave.</div>
    </div>
    <div class="leave" v-if="showDatepicker" style="border-bottom: 1.5px dashed #d4cccc;">
    <div class="row">
      <div class="col-md-3">
         <div class="form-group">
          <label style="font-size: 12px;">Select Range</label>
          <span class="validation-star">*</span>
          <ob-date-time-picker
            :inputvalue="LeaveDateFrom"
            v-model.trim="LeaveDateFrom"
            ref="dateFrom"
            id="dateFrom"
            :options="options4"
            @updated="fromDateUpdate"
            :dpchange="onFromDateChange"
            :class="{ 'ob-vuelidate_input-error': $v.LeaveDateFrom.$error }"
            :DisabledDateDetails="disabledDatesMetaData"
          ></ob-date-time-picker>
          <span
            class="ob-vuelidate_error-msg"
            v-if="$v.LeaveDateFrom.$dirty && !$v.LeaveDateFrom.required"
          >Please select</span>
        </div>
      </div>
      <div class="col-md-3" style="margin-top:25px">
       <ob-select2  :options="leaveActivity"   v-model="activityLeave" :class="{ 'ob-vuelidate_input-error': $v.activityLeave.$error }"></ob-select2>
       <span
            class="ob-vuelidate_error-msg"
            v-if="$v.activityLeave.$dirty && !$v.activityLeave.required"
          >Please select</span>
      </div>
       <!-- <div class="col-md-3" style="margin-top:30px" >
        <div style="border: 1px solid;
  padding: 10px;background-color:#C0C0C0"> <p class="text-center">5</p> 
 <p class="text-center"> Days Taken</p></div>
  
      </div>
      <div class="col-md-3" style="margin-top:30px" >
        <div style="border: 1px solid;
  padding: 10px;background-color:#C0C0C0"><p class="text-center"> 8</p><p class="text-center"> Days Avaliable</p></div>
  
      </div> -->
      </div>
       <div class="row " style="padding-top:0px">
      <div class="col-md-3">
         <div class="form-group">
          <label></label>
          <ob-date-time-picker
            :inputvalue="LeaveDateTo"
            v-model.trim="LeaveDateTo"
            style="margin-top: -20px;"
            ref="dateTo"
            id="dateTo"
            :options="options4"
            @updated="toDateUpdate"
            :class="{ 'ob-vuelidate_input-error': $v.LeaveDateTo.$error }"
            :DisabledDateDetails="disabledDatesMetaData"
          ></ob-date-time-picker>
           <span
            class="ob-vuelidate_error-msg"
            v-if="$v.LeaveDateTo.$dirty && !$v.LeaveDateTo.required"
          >Please select</span>
         
        </div>
      </div>
      <div class="col-md-3" style="margin-top: 0px;">
         <ob-select2  :options="leaveActivity12"   v-model="activityLeave12" :class="{ 'ob-vuelidate_input-error': $v.activityLeave12.$error }"></ob-select2>
         <span
            class="ob-vuelidate_error-msg"
            v-if="$v.activityLeave12.$dirty && !$v.activityLeave12.required"
          >Please select</span>
      </div>
     
      
      </div>
      <a v-if="this.diffBetweenTwodates > 0" style="margin-bottom:20px;text-decoration:none">{{this.diffBetweenTwodates * 8}} hours ({{this.diffBetweenTwodates}} 
        <span v-if="this.diffBetweenTwodates > 1"> days</span><span v-if="this.diffBetweenTwodates <= 1"> day</span>) selected</a>
      <span class="ob-vuelidate_error-msg" v-else-if="activityLeave == 'MidDay' && activityLeave12 == 'MidDay'">No of hours should be greater than 4hours</span>
      <!-- <a v-else style="margin-bottom:20px;text-decoration:none">{{this.diffBetweenTwodates * 8}} hours ({{this.diffBetweenTwodates}} day) selected</a> -->
   <!-- <a style="margin-bottom:20px;text-decoration:none">{{item.TotalDays*8}}hours selected</a> -->
      </div>
    <!-- <div v-if="showDatepicker" class="row">
      <div class="col-md-2 pR0">
        <div class="form-group">
          <label style="font-size: 12px;">Select Range</label>
          <span class="validation-star">*</span>
          <ob-date-time-picker
            :inputvalue="LeaveDateFrom"
            v-model.trim="LeaveDateFrom"
            ref="dateFrom"
            id="dateFrom"
            :options="options4"
            @updated="fromDateUpdate"
            :dpchange="onFromDateChange"
            :class="{ 'ob-vuelidate_input-error': $v.LeaveDateFrom.$error }"
            :DisabledDateDetails="disabledDatesMetaData"
          ></ob-date-time-picker>
          <span
            class="ob-vuelidate_error-msg"
            v-if="$v.LeaveDateFrom.$dirty && !$v.LeaveDateFrom.required"
          >Please select</span>
        </div>
      </div>
     
        <ob-dropdown title="Start of the Day" class="js-stop-propagate-class" >
   <template >
     <ob-dropdown-list-item >Mid Day </ob-dropdown-list-item>
   <ob-dropdown-list-item >Morning
  
   </ob-dropdown-list-item>
    
   </template>
  </ob-dropdown>
        
      <div class="col-md-2 pR0">
        <div class="form-group">
          <label></label>
          <ob-date-time-picker
            :inputvalue="LeaveDateTo"
            v-model.trim="LeaveDateTo"
            style="margin-top: 5px;"
            ref="dateTo"
            id="dateTo"
            :options="options4"
            @updated="toDateUpdate"
            :class="{ 'ob-vuelidate_input-error': $v.LeaveDateTo.$error }"
            :DisabledDateDetails="disabledDatesMetaData"
          ></ob-date-time-picker>
          <span
            class="ob-vuelidate_error-msg"
            v-if="$v.LeaveDateTo.$dirty && !$v.LeaveDateTo.required"
          >Please select</span>
        </div>
        <ob-dropdown title="Start of the Day" class="js-stop-propagate-class" >
   <template >
     <ob-dropdown-list-item >Mid Day </ob-dropdown-list-item>
   <ob-dropdown-list-item >Morning
  
   </ob-dropdown-list-item>
    
   </template>
  </ob-dropdown>
      </div>
      <div v-if="IsCoincide" class="row" style="margin-bottom:10px;">
        <div class="col-md-12" style="padding-left:20px">
          <img
            :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/info-icon-orange.svg`"
            style="width:18px;border-radius:50%;margin-left:10px;margin-right:6px;"
          />
          <span
            style="color:#F07431"
          >This leave range coincides with a previously applied leave ({{coinsideDateFrom}} to {{coinsideDateTo}}).</span>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div
        class="col-md-12 pL0"
        style="font-weight: 400;margin-top: 15px;"
      >
        <label style="padding-left: 15px;font-size: 12px;">Time Off Code</label>
        <span class="validation-star">*</span>
        <div class="form-group" style="margin-bottom: 0;" v-if="balanceLeaves && balanceLeaves.length > 0">
          <template v-for="(item,index) in balanceLeaves">
            <div :key="index" class="radio-inline mL0">
              <ob-radio
                :disabled="IsLeaveTypeDisable(item)"
                name="leaveType"
                :val="item.LeaveType"
                v-model="Leavetype"
              >{{item.LeaveType}} ( {{item.Count}} day(s) )</ob-radio>
            </div>
          </template>
          <!-- <div class="radio-inline mL0">
            <ob-radio name="leaveType" :val="'UnPaid'" v-model="Leavetype">{{'UnPaid'}}</ob-radio>
          </div> -->
        </div>
        <div class="form-group" style="margin-bottom: 0;" v-else>
          <span style="padding-left: 15px;text-transform:none; font-weight: 400; color: orange;">There are no Time off codes available. Please contact your employer</span>
        </div>
        <span
          style="margin-left: 15px;"
          class="ob-vuelidate_error-msg"
          v-if="$v.Leavetype.$dirty && !$v.Leavetype.required"
        >Please select Time Off Code</span>
      </div>
      <div class="col-md-12" v-if="LeavetypeOptions.data.length > 0 && Leavetype != 'UnPaid'">
        <span style="color:rgb(250, 100, 0);font-weight: 600;font-size:14px">
          Note: You have only {{SlectedLeave.Count}} {{SlectedLeave.Key}} leave(s) available. Please select other time off code from which you want to deduct the remaining leaves
          <ob-select2
            style="width: 180px;display: inline-block;"
            :options="LeavetypeOptions"
            v-model="DropDownLeavetype"
          ></ob-select2>
        </span>
        <span
          style="color:rgb(250, 100, 0);font-weight: 600;font-size:14px;display: inline-block;"
          v-if="showDropdownContent"
        >Note: If you are availing more leaves than available, then those will be considered as unpaid leaves by default.</span>
        <!-- <span  class="ob-vuelidate_error-msg" v-if="$v.DropDownLeavetype.$dirty && !$v.DropDownLeavetype.required">Please select Leave Type</span> -->
      </div>
      <div class="col-md-12" style="margin-top: 15px;">
        <div class="form-group">
          <label style="font-size: 12px;">Leave Reason</label>
          <span class="validation-star">*</span>
          <ob-textarea
            :height="'70px'"
            placeholder="Enter Leave Reason "
            v-model.trim="leaveReason"
            :maxLength="1200"
            :class="{ 'ob-vuelidate_input-error': $v.leaveReason.$error }"
          ></ob-textarea>
          <span
            class="ob-vuelidate_error-msg"
            v-if="$v.leaveReason.$dirty && !$v.leaveReason.required"
          >Please enter</span>
        </div>
      </div>
    </div>
    <div class="row" style="margin: 5px 0;">
      <ob-checkbox v-model="IsTravellingOutOfCountry" :val="1">
        <b style="font-size: 13px;font-weight:600">Travelling out of country</b>
      </ob-checkbox>
    </div>
    <div class="row" style="margin-top: 25px;min-height: 86px;">
      <div class="col-md-12">
        <template v-for="(item,index) in Attachments">
          <div :key="index" class="attachments-view">
            <template>
              <span id="task-title">{{getFileName(item)}}</span>
            </template>
            <ob-popover trigger="click" :options="{placement: 'bottom'}">
                <div class="popper" style="padding:0px">
                    <div style="padding:10px;">
                        <span :class="{'cursorCls': !isFileType(item)}" >
                          <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                        </span>
                        <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                        <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                    </div>
                </div>
                <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-left:10px" />
            </ob-popover>
            <span
              style="margin-top: -25px; padding-top: 2px;padding-bottom: 6px;margin-left: 0px"
            >
              <span
                class="cross-mark"
                @click="removeAttachment(index)"
                style="font-size: 11px; padding: 2px 5px;"
              >&#10006;</span>
            </span>
          </div>
        </template>
        <div v-if="showAttachmentDiv">
          <ob-upload-attachment
            ref="upload"
            @error-msg="IsInvalidFile"
            @file-inProgress="InProgress"
            @file-complete="onuploadComplete"
            :validation="ValidationType"
            :end-point="EndPoint"
            :type="1"
            :IsFileExists="filename"
            :attach-file.sync="attachFile"
          >
            <template slot="file-text">
              <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
            </template>
          </ob-upload-attachment>
        </div>
        <div class="form-group col-md-12 pL0">
          <div class="col-md-3 pL0">
            <a @click="onAddAtachment()">
              <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" />
              <span
                style="color: #000000;font-weight: 600;font-size: 12px;margin-right:3px;"
              >Add Attachments</span>
            </a>
          </div>
          <div class="col-md-12 pL0" style="margin-bottom:6px;padding-top:8px;">
            <span
              style="font-style: italic;color: #9f9f9f;"
            >We accept either pdf, doc, docx, zip, images upto 25MB.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" style="border-top:1.2px solid #ddd; padding-top: 12px;">
        <div class="form-group">
          <ob-button type="secondary" @click="cancel()">Cancel</ob-button>
          <ob-button :disabled="diasbleApplyButton" @click="isValid()">Apply</ob-button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12" style="height: 100%;overflow-x:hidden" v-else>
    <div class="MT-Content-table">
      <div class="MT-Content">
        <div style="font-weight: 600;">Your employer hasn't set any leave policy for you.<br>
          Please contact your employer.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import c from "Vue/Core/constants.js";
import utils from "Vue/Core/utils.js";
import CommonFunctionMixin from '../Timesheets/CommonFunctionMixin.js'
import {
  required,
  minLength,
  maxLength,
  requiredIf,
  email
} from "vuelidate/lib/validators";

export default {
  mixins: [CommonFunctionMixin],
  props: ["content"],
  data() {
    return {
      activityLeave:'',
      activityLeave12:'',
      diffBetweenTwodates: '',
      IsEnableTimeOff:true,
      leaveData:'',
      DropDownLeavetype: "",
      SlectedLeave: {},
      coinsideDateFrom: "",
      coinsideDateTo: "",
      appliedLeaves: [],
      IsCoincide: false,
      Leavetype: "",
      leaveReason: "",
      showAttachmentDiv: false,
      IsTravellingOutOfCountry: false,
      LeaveDateFrom: "",
      LeaveDateTo: "",
      disabledDatesMetaData: [],
      showDatepicker: false,

      isUploading: false,
      //Attachemnts
      Attachments: [],

      ValidationType: {
        Rules: {
          Type: [
            "pdf",
            "zip",
            "doc",
            "docx",
            "png",
            "gif",
            "jpg",
            "jpeg"
          ],
          Size: 26000000, // In Bytes
          multiplefiles: true
        },
        Messages: {
          Type: "Please upload valid file formats",
          Size: `Please upload a file which is less than 25MB`
        },
        excludeList: false
      },
      filename: [],
      EndPoint: `${c.APIBASEURL}/File/FileUpload`,
      attachFile: false,
      options4: {
        // daysOfWeekDisabled: [0,6],
        format: "MM/DD/YYYY",
        dayViewHeaderFormat: "MM/DD/YYYY",
        // minDate : moment(new Date()),
        ignoreReadonly: true,
        disabledDates: []
      },

      LeavetypeOptions: {
        placeholder: {
          id: "-1",
          text: "Select Time Off Code"
        },
        data: []
      },
       leaveActivity: {
                data: [ { id: 'StartOfTheDay', text: 'Start  of Day' },
                        { id: 'MidDay', text: 'Mid Day' },
                ],
                placeholder: {
                    id: '-1',
                    text: 'Select '
                }
            },
         leaveActivity12: {
                data: [ { id: 'MidDay', text: 'Mid Day' },
                        { id: 'EndOfTheDay', text: 'End of Day' },
                ],
                placeholder: {
                    id: '-1',
                    text: 'Select '
                }
            },
    };
  },
  components: {},
  computed: {
    consultantDetails() {
                return this.$store.getters.getConsultantDetails
            },
    balanceLeaves(){
      if(this.leaveData != null && this.leaveData.LeaveCountData != null)
      {
         return this.leaveData.LeaveCountData.BalanceLeaves
      }
    },
    showDropdownContent() {
      var dropDownLeavetype = this.DropDownLeavetype;
      if (dropDownLeavetype != "" && dropDownLeavetype != "UnPaid") {
        var dropDownCount = this.balanceLeaves.filter(function(v) {
          return v.Key == dropDownLeavetype;
        })[0].Count;
        var leaveAppliedDates = this.LeaveAppliedDates();
        var daysDiff = leaveAppliedDates.length;
        if (daysDiff > dropDownCount + this.SlectedLeave.Count) {
          return true;
        } else return false;
      } else {
        return false;
      }
    },
    diasbleApplyButton() {
      if (
        this.leaveReason == null ||
        this.leaveReason == "" ||
        this.activityLeave == null ||
        this.activityLeave == "" ||
        this.activityLeave12 == null ||
        this.activityLeave12 == " " ||
        this.LeaveDateFrom == "" ||
        this.LeaveDateFrom == null ||
        this.LeaveDateTo == "" ||
        this.LeaveDateTo == null ||
        this.IsCoincide == true ||
        this.Leavetype == "" ||
        (this.LeavetypeOptions.data.length > 0 &&
          this.Leavetype != "UnPaid" &&
          this.DropDownLeavetype == "")
      )
        return true;
      else return false;
    },
    EmployeeId() {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : "";
    }
  },
  validations() {
    return {
      LeaveDateFrom: {
        required
      },
      LeaveDateTo: {
        required
      },
      leaveReason: {
        required
      },
      Leavetype: {
        required
      },
      activityLeave: {
        required
      },
      activityLeave12: {
        required
      },
      DropDownLeavetype: {
        requiredIf: requiredIf(a => {
          if (
            this.LeavetypeOptions.data.length > 0 &&
            this.Leavetype != "UnPaid"
          ) {
            return true;
          } else {
            return false;
          }
        })
      }
    };
  },
  watch: {
    LeaveDateFrom(val) {
      if (val != null && val != "") {
        this.callDateRange();
      }
    },
    LeaveDateTo(val) {
      if (val != null && val != "") {
        this.callDateRange();
      }
    },
    Leavetype(val) {
      this.onLeaveTypeChange(val);
    },
      activityLeave(val)
    {
      this.disableTimeOffcodesBasedOnDates()
    },
    activityLeave12(val)
    {
      this.disableTimeOffcodesBasedOnDates()
    }
  },
  created() {
    this.resetdata();
    this.getOrganizationHolidays();
  },
  methods: {
    IsLeaveTypeDisable(item){ 
     var leaveCount = parseFloat(item.Count);
      if(item.IsDisable && leaveCount <= 0)
      {
        return true;
      }
      else if(item.IsDisable && (leaveCount - this.diffBetweenTwodates) < 0)
      {
        return true;
      }
      else if(!item.IsAllowEntriesOutsideAccrualYear && moment(item.AccrualYearEndDate) < moment(this.LeaveDateTo))
      {
        return true;
      }
      return false;
    },
     disableTimeOffcodesBasedOnDates() {
      if(this.LeaveDateFrom != '' && this.LeaveDateFrom != null && this.LeaveDateTo != '' && this.LeaveDateTo != null){
        var list = this.enumerateDaysBetweenDates(moment(this.LeaveDateFrom) ,moment(this.LeaveDateTo));
        var remainingList = __.difference(list, this.options4.disabledDates);
        if(remainingList.length > 0){
            this.diffBetweenTwodates = remainingList.length;
            if((this.activityLeave == "StartOfTheDay" && this.activityLeave12 == "MidDay") || (this.activityLeave == "MidDay" && this.activityLeave12 == "EndOfTheDay"))
            {
                this.diffBetweenTwodates = this.diffBetweenTwodates - 0.5;
            }
            else if(this.activityLeave == "MidDay" && this.activityLeave12 == "MidDay")
            {
                this.diffBetweenTwodates = this.diffBetweenTwodates - 1;
            }
        }else{
          this.diffBetweenTwodates = 0
        }
      }
    },
    onLeaveTypeChange(v) {
      this.LeavetypeOptions.data = [];
      var leaveTypeSelected = v;
      var leaveAppliedDates = this.LeaveAppliedDates();
      var daysDiff = leaveAppliedDates.length;
      var selectedLeave = this.balanceLeaves.filter(function(v) {
        return v.Key == leaveTypeSelected;
      });
      this.SlectedLeave = selectedLeave[0];
      var selectedLeaveCount = 0;
      if (selectedLeave.length > 0) {
        selectedLeaveCount = selectedLeave[0].Count;
      }
      if (
        this.leaveData && this.leaveData.LeaveCountData &&
        this.balanceLeaves.length > 0 &&
        selectedLeaveCount != 0 &&
        daysDiff > 1 &&
        daysDiff > selectedLeaveCount
      ) {
        var x = this.balanceLeaves.filter(function(v) {
          return v.Count > 0 && v.Key != leaveTypeSelected;
        });
        setTimeout(() => {
          this.LeavetypeOptions.data = __.map(x, t => {
            return { id: t.Key, text: t.Key };
          });
          this.LeavetypeOptions.data.push({ id: "UnPaid", text: "UnPaid" });
        }, 10);
      }
    },
    getAppliedLeaves() {
      var itr = moment
        .twix(this.LeaveDateFrom, this.LeaveDateTo)
        .iterate("days");
      var range = [];
      while (itr.hasNext()) {
        range.push(itr.next().format("MM/DD/YYYY"));
      }
      var intersections = this.appliedLeaves.filter(
        e => range.indexOf(e) !== -1
      );

      if (intersections.length > 0) {
        this.IsCoincide = true;
        this.coinsideDateFrom = intersections[0];
        this.coinsideDateTo = intersections.slice(-1)[0];
      } else {
        this.IsCoincide = false;
      }
    },
    dateRangeDays() {
      this.getAppliedLeaves();
      this.onLeaveTypeChange(this.Leavetype);
    },
    callDateRange() {
      if (
        this.LeaveDateFrom != "" &&
        this.LeaveDateTo != "" &&
        this.LeaveDateTo != null &&
        this.LeaveDateFrom != null
      ) {
        this.dateRangeDays();
        this.Leavetype = '';
        this.disableTimeOffcodesBasedOnDates();
      }
    },
    fromDateUpdate(v) {
      var index = this.options4.disabledDates.indexOf(v);
      if (index > -1) {
        this.LeaveDateFrom = null;
      } else {
        this.LeaveDateFrom = v;
      }
    },
    toDateUpdate(v) {
      var index = this.options4.disabledDates.indexOf(v);
      if (index > -1) {
        this.LeaveDateTo = null;
      } else {
        this.LeaveDateTo = v;
      }
    },
     getOrganizationHolidays() {
      this.showDatepicker = false;
      var currentYear = moment().format("YYYY");
      var empId = this.loggedInUserObj.empId;
      this.$loading({loadingText: 'Loading...'})
      ajax.get(
        `Leave/${empId}/EmployeeLeaveData?year=${currentYear}`,
        {},
        res => {
          this.leaveData = res.data.LeaveData;
          this.IsEnableTimeOff = this.leaveData.LeaveDisabledData.IsEnableTimeOff
          if(this.IsEnableTimeOff){
            let disableLeaves = this.leaveData.LeaveDisabledData.DisableDate
            let leaveAppliedDateMetaData = disableLeaves.map(function(x) {
              return {
                Date: x.Date,
                Title: x.Title
              };
            });
            this.disabledDatesMetaData = leaveAppliedDateMetaData
            let disabledDates = leaveAppliedDateMetaData.map(function(i) {
              return i.Date;
            });

            // adding weekends to the disabled dates
            var cdate = moment(new Date());
            var prev = moment().add(-1, "years");
            var next = moment().add(1, "years");
            var results = this.enumerateDaysBetweenDates(prev, next);
            var weekends = this.getWeekendList(this.leaveData.LeaveDisabledData.WeekOffDays);
            this.options4.disabledDates =  disabledDates.concat(weekends);

            this.showDatepicker = true;
            }
          this.$loading({}).close()
        }
      );
    },
    getWeekendList(list)
    {
      let dayNumList = [];

      if (list.includes("SUN"))
          dayNumList.push(0);
      if (list.includes("MON"))
          dayNumList.push(1);
      if (list.includes("TUE"))
          dayNumList.push(2);
      if (list.includes("WED"))
          dayNumList.push(3);
      if (list.includes("THU"))
        dayNumList.push(4);
      if (list.includes("FRI"))
          dayNumList.push(5);
      if (list.includes("SAT"))
          dayNumList.push(6);

      var startDate = moment().add(-1, "years");
      var endDate = moment().add(1, "years");

      let weekends = [];
      var now = startDate;
      while (now.isSameOrBefore(endDate)) {
        var dt = new Date(now);
        if(dayNumList.includes(dt.getDay()))
        {
          weekends.push(now.format("MM/DD/YYYY"));
        }
        now.add(1, "days");
      }
      return weekends;
    },
    enumerateDaysBetweenDates(startDate, endDate) {
      var now = startDate,
        dates = [];

      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format("MM/DD/YYYY"));
        now.add(1, "days");
      }
      return dates;
    },
    cancel() {
      this.resetdata();
    },
    resetdata() {
      this.Leavetype = "";
      this.leaveReason = "";
      this.showAttachmentDiv = false;
      this.IsTravellingOutOfCountry = false;
      this.LeaveDateFrom = "";
      this.LeaveDateTo = "";
      this.isUploading = false;
      this.activityLeave="",
      this.activityLeave12="",
      this.Attachments = [];
      this.$v.LeaveDateFrom.$reset();
      this.$v.LeaveDateTo.$reset();
      this.$v.leaveReason.$reset();
      this.$v.Leavetype.$reset();
      this.$v.activityLeave.$reset();
      this.$v.activityLeave12.$reset();
      this.$v.DropDownLeavetype.$reset();
      
    },
    onFromDateChange(e) {
      this.$refs.dateFrom.data.minDate(this.consultantDetails.EmpStartDate);
      var d1 = e.date.format("MM/DD/YYYY");
      var d = moment(e.date).subtract(1, "days");
      var d2 = d.format("MM/DD/YYYY");
      var index1 = this.options4.disabledDates.indexOf(d1);
      var index2 = this.options4.disabledDates.indexOf(d2);
      if (index2 > -1 && index1 > -1) {
        this.$refs.dateTo.data.minDate(d2);
      } else {
        this.$refs.dateTo.data.minDate(d1);
      }
    },
    onAddAtachment() {
      this.showAttachmentDiv = true;
      this.open();
    },
    getFileName(item) {
      var filename = utils.I9URL2FileName(item);
      var fileLength = filename.length;
      if (fileLength > 33) {
        return filename.substring(0, 30) + "...";
      } else return filename;
    },
    isFileType(item)
      {
        var filename = utils.I9URL2FileName(item);
        var fileExtention = filename.split('.').pop();
        var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
        return FileTypes.includes(fileExtention)
      },
    open() {
      setTimeout(() => {
        this.$refs.upload.uploadNew();
      }, 1000);
    },
    IsInvalidFile(error) {
      if (error != "") {
        this.$message({
          type: "error",
          message: error
        });
      }
    },
    InProgress() {
      this.$loading({ loadingText: "Loading..." });
      this.showAttachmentDiv = true;
    },
    onuploadComplete(v) {
      for (var i = 0; i < v.length; i++) {
        if (v[i].response.Url != null) this.Attachments.push(v[i].response.Url);
      }
      this.showAttachmentDiv = false;
      this.$loading({}).close();
    },
    removeAttachment(index) {
      this.Attachments.splice(index, 1);
    },
    isValid() {
      this.$v.LeaveDateFrom.$touch();
      this.$v.LeaveDateTo.$touch();
      this.$v.leaveReason.$touch();
      this.$v.Leavetype.$touch();
      this.$v.activityLeave.$touch();
      this.$v.activityLeave12.$touch();
      this.$v.DropDownLeavetype.$touch();

      if (
        this.$v.LeaveDateFrom.$error == false &&
        this.$v.LeaveDateFrom.$error == false &&
        this.$v.leaveReason.$error == false &&
        this.$v.Leavetype.$error == false &&
        this.$v.activityLeave.$error == false &&
        this.$v.activityLeave12.$error == false &&
        this.$v.DropDownLeavetype.$error == false && this.diffBetweenTwodates > 0
      ) {
        this.ApplyLeave();
      }
    },
    LeaveAppliedDates() {
      var dateArray = this.enumerateDaysBetweenDates(
        moment(this.LeaveDateFrom),
        moment(this.LeaveDateTo)
      );
      var disabledDates = this.disabledDatesMetaData.map(function(i) {
        return i.Date;
      });
      var LeaveAppliedDates = dateArray.filter(
        x =>
          !disabledDates.includes(x) &&
          new Date(x).getDay() != 0 &&
          new Date(x).getDay() != 6
      );
      return LeaveAppliedDates;
    },
    ApplyLeave() {
      this.$loading({ loadingText: "Loading..." });
      var leaveObject = {
        EmployeeID: this.EmployeeId,
        From: this.LeaveDateFrom,
        To: this.LeaveDateTo,
        LeaveType: this.Leavetype,
        LeaveReason: this.leaveReason,
        StartDay:this.activityLeave,
        EndDay:this.activityLeave12,
        IsTravellingOutOfCountry: this.IsTravellingOutOfCountry,
        Documents: [],
        Attachments: this.Attachments,
        OtherLeaveType: this.DropDownLeavetype
      };
      ajax.post(
        `/Leave/ApplyMultipleLeaves?empOrgId=${this.loggedInUserObj.orgId}`,
        leaveObject,
        res => {
          if (res.data.State == true) {
            this.$loading({}).close();
            this.$message({
              type: "success",
              message: ResourceCore.Messages["Leave_Applied"]
            });
            this.$router.push({ name: "leave-history" });
          } else if (res.data.State == false) {
            this.$loading({}).close();
            res.data.state = false;
            res.data.HasRestriction = true;
            this.ESSEnableDisable(res);
            this.$message({
              type: "error",
              message: res.data.Message
            });
          }
        }
      );
    }
  }
};
</script>
<style scoped>
.attachments-view {
  margin-bottom: 5px;
  /* color: #4a90e2; */
  margin-left: 0px;
  border: 1px solid #4a90e2 !important;
  background: #e6eff9 !important;
  padding: 5px 10px;
  display: inline-block;
  border-radius: 30px;
  font-weight: bold;
  float: left;
  margin-right: 2%;
}
.cross-mark {
  font-size: 15px;
  padding: 0px 5px;
  border-radius: 100%;
  cursor: pointer;
}
.cross-mark:hover {
  background: #c2c2c2;
  padding: 0px 5px;
  border-radius: 100%;
  text-decoration: none !important;
}
.remove-doc {
  color: #d0032e;
  font-size: 12px;
  font-style: italic;
  font-weight: bolder;
  text-decoration: underline;
  /* float: right; */
}
.add-doc {
  font-size: 12px;
  font-style: italic;
  font-weight: bolder;
  text-decoration: underline;
  color: #4a92e8;
}
.validation-star {
  color: #d0032e;
}
.leave-counts {
  text-transform: capitalize;
}
label {
  font-weight: 600 !important;
}
.cursorCls
{
  cursor:not-allowed !important;
}
.hideShow
{
  pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/LeaveManagement/ApplyLeave.vue